import { useMutation } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';

interface Payload {
  soldPrice: number | string;
  yearBuilt: string;
  subjectImg: string;
  comparableImg: string;
  address: string;
}

export default function useCompareProperty() {
  const token = window.localStorage.getItem('_token');

  const propertyInfo = JSON.parse(
    window.localStorage.getItem('propertyInfo') || null,
  );

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/properties/compare-properties`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            subjectProperty: {
              address: propertyInfo.address.label,
              imageUrl: payload.subjectImg,
              soldPrice: propertyInfo.marketValue,
              yearBuilt: propertyInfo.mls?.YearBuilt || propertyInfo.yearBuilt,
            },
            comparableProperty: {
              address: payload.address,
              imageUrl: payload.comparableImg,
              soldPrice: payload.soldPrice,
              yearBuilt: payload.yearBuilt,
            },
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
  });
}
